/**
 * Name of the main Algolia index for products. Consumer-specific (it ties to
 * how this app shapes its Algolia indices), so it stays here.
 */
export const ALGOLIA_PRODUCTS_INDEX = "products";

/**
 * URL builders for the brand-refinement and text-query landings are shared
 * with `@repo/ui` (see secondary nav) — they live in `@repo/ui/lib/algolia-url`
 * to avoid a circular dep with `@repo/next-shared`. Re-export them here so
 * the rest of the consumer keeps a single, stable import path.
 */
export { brandSearchUrl, searchQueryUrl } from "@repo/ui/lib/algolia-url";
